import { ErrorResponse } from '@gtpl/shared-models/common-models';
import {  AllGradingMonitoringResponseModel, GradingMonitoringResponseModel} from '@gtpl/shared-models/production-management';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getManager, Raw,Repository } from 'typeorm';
import { GradeMonitoringAdapter } from '../dto/grade-monitoring.adapter';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { GradingMonitoring } from '../entities/grading-monitoring.entity';
import { GradingMonitoringDTO } from '../dto/grading-monitoring.dto';
import { GradeMonitoringRepository } from '../repositories/grade-monitoring.repository';
import { GradeInventoryIdRequest } from '../dto/grad-inv-id-req';
import appSettings from 'apps/services/config';
const gradeMonitoringTable = appSettings.production_db + '.grading_monitoring'
const salesSoTable = appSettings.sales_db + '.sale_order';
const salesSoItemTable=appSettings.sales_db + '.sale_order_items'

@Injectable()
export class GradingMonitoringService {

    constructor(
        @InjectRepository( GradingMonitoring)
        private repo:Repository<GradingMonitoring>,
        private adapter: GradeMonitoringAdapter,
        
    ) { }

    async createGradingMonitoring(dto:GradingMonitoringDTO, isUpdate: boolean): Promise<GradingMonitoringResponseModel> {
        
        try {
           
          const convertedEntity: GradingMonitoring = this.adapter.convertDtoToEntity(dto,isUpdate);
          const savedEntity: GradingMonitoring = await this.repo.save(
            convertedEntity
          );
         
                     if (savedEntity) {
            // generating resposnse
        const response = new GradingMonitoringResponseModel(true,1,isUpdate? 'GradingMonitoring Updated Successfully': 'GradingMonitoring Created Successfully');
        return response;

          } else {
            //return new InformationMessageError(11106, "State saved but issue while transforming into DTO");
            throw new ErrorResponse(11106,'GradingMonitoring saved but issue while transforming into DTO');
          }
        } catch (error) {
          // when error occures while saving the data , the execution will come to catch block.
          // tslint:disable-next-line: typedef
          return error;
        }
      }  


    //   async getSamplesInfoByGrdInvId(req:GradeInventoryIdRequest):Promise<AllGradingMonitoringResponseModel> {
    //     try{
    //         const logInfo = await this.repo.getSamplesInfoByGrdInvId(req);
    //         if(logInfo){
    //             return new AllGradingMonitoringResponseModel(true, 1111, 'Data Found Successfully', logInfo)
    //         }else{
    //             return new AllGradingMonitoringResponseModel(false, 9999, 'No Data Found',)
    //         }
    //     }catch(error){
    //         return error;
    //     }
    // }

    async getSamplesInfoByGrdInvId(Req: GradeInventoryIdRequest): Promise<AllGradingMonitoringResponseModel> {
      try {
        //retrieves all companies
        const dto:GradingMonitoringDTO[]=[]
        const entities: GradingMonitoring[] = await this.repo.find({
            where:{gradingInventoryId:Req.gradeInventoryId}
            });
            
           
            if (entities) {
              entities.forEach(sample =>{
                const gradingMonDto:GradingMonitoringDTO = this.adapter.convertEntityToDto(sample)
                dto.push(gradingMonDto)
              })
                const response = new AllGradingMonitoringResponseModel(true, 11101 , 'Samples retrived Successfully',dto);
                return response;
            }
            else{
                throw new ErrorResponse(11106,'Something went wrong');
            }
            // generating resposnse
    } catch (err) {
        return err;
    }
  }

  async getAllGradeMonitoring(): Promise<AllGradingMonitoringResponseModel> {
    try {
        const manager = getManager()
        const query = `SELECT  s.saleOrder_Id as saleOrderId,s.saleorder_item_id as saleOrderItemId,s.grading_monitoring_id as gradingMonitoringId,s.lot_number as lotNumber,so.sale_order_no as soNumber,  concat(b.brand_name, "/", p.name, "/", soi.min_grade_id,'-',soi.max_grade_id) as item,p.name as product,traceability_code as traceabilityCode, s.country, s.totalMCs FROM ` + gradeMonitoringTable + ` s 
        LEFT JOIN ` + salesSoItemTable + ` soi ON soi.sale_order_item_id=s.saleorder_item_id 
        LEFT JOIN ` + salesSoTable + ` so ON so.sale_order_id=s.saleOrder_Id
        LEFT JOIN ` + appSettings.masters_db + `.brands b ON b.brand_id=soi.brand_id
        LEFT JOIN `+ appSettings.masters_db + `.products p ON p.product_id=soi.item_id
        LEFT JOIN `+ appSettings.masters_db + `.sku_codes sc ON sc.sku_code_id=soi.varient_id
        ORDER BY  grading_monitoring_id ASC` 
        const qEntities: GradingMonitoringDTO[] = await manager.query(query)
        if (qEntities) {

            const response = new AllGradingMonitoringResponseModel(true, 1, 'Grade Monitoring retrieved successfully', qEntities);
            return response;
        } else {
            throw new ErrorResponse(99998, 'Data Not Found');
        }
    } catch (err) {
        console.log(err)
        return err;
    }
}

}
